import { render } from "./Honorary.vue?vue&type=template&id=7b9f5c92&scoped=true"
import script from "./Honorary.vue?vue&type=script&lang=js"
export * from "./Honorary.vue?vue&type=script&lang=js"

import "./Honorary.vue?vue&type=style&index=0&id=7b9f5c92&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9f5c92"]])

export default __exports__